import * as reactQuery from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";
import { useCountertopUniversity } from "../contexts/countertopUniversityContext";

export const useSaveCountertopUniversityVideo = (
	countertopUniversityID: number,
	videoPercentage: number,
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const context = useCountertopUniversity();

	const { mutate, isLoading } = reactQuery.useMutation({
		mutationFn: async () => {
			return await apiClient.post("countertop-university/save-video", {
				countertopUniversityID: countertopUniversityID,
				videoPercentage: videoPercentage,
				profileID: context.profileID
			}) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when saving the video percentage: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
